import { render } from "./StatsWell.vue?vue&type=template&id=16b8f51c&scoped=true"
import script from "./StatsWell.vue?vue&type=script&lang=js"
export * from "./StatsWell.vue?vue&type=script&lang=js"

import "./StatsWell.vue?vue&type=style&index=0&id=16b8f51c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16b8f51c"]])

export default __exports__